




















































































































































































































































import Vue from 'vue'
import { ApiResponse, Sale, Requisition, Structure } from '@/interfaces'
import { mapState } from 'vuex'
import { stockStatuses, defaultStockStatuses } from '@/formHelpers'

interface Rubrique {
  children?: Rubrique[]
  label: string
  value: string
}

interface Parameter {
  tab?: string
  search?: string
  storageArea?: string
  page?: string
  orderby?: string
  order?: string
  rubriques?: string[]
  stockStatuses?: string[]
  entryDate?: string[]
  itemNumber?: string
  stockId?: string
  sale?: number
  requisition?: number
  expert?: number
  apporteur?: number
  dateOut?: string
  structure?: string
  specialFilter?: string
  sort?: string
}

export default Vue.extend({
  //name: 'ItemFilters',
  props: {
    parentPage: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      addons: 0,
      busy: false,
      search: '',
      storageArea: '',
      page: '1',
      activePage: 1,
      itemsTotal: 0,
      numPages: 1,
      orderBy: null as null | string,
      order: null as null | string,
      sales: [] as Sale[],
      cascaderProps: { multiple: true },
      stockStatuses,
      filteredStockStatuses: [...defaultStockStatuses] as string[],
      chosenStockStatuses: defaultStockStatuses.map((status) => [status]) as string[][],
      filteredRubriques: [] as string[],
      chosenRubriques: [] as string[][],
      rubriques: [],
      entryPeriod: [] as string[],
      query: {},
      saleFilter: null as number | null,
      entryPeriodFilter: [] as string[],
      itemNumberFilter: null as string | null,
      stockIdFilter: null as string | null,
      requisitions: [] as Requisition[],
      requisitionFilter: null as number | null,
      experts: [], // as string[],
      expertFilter: null as number | null,
      apporteurs: [], // as string[],
      apporteurFilter: null as number | null,
      dateOutFilter: false,
      structures: [] as Structure[],
      structureFilter: null as string | null,
      specialFilter: null as string | null,
      itemFilters: [
        {
          label: 'Filtres préparation de vente',
          options: [
            {
              value: 'sans_photos',
              label: 'Photos manquantes',
            },
            {
              value: 'sans_estimations',
              label: 'Estimations manquantes',
            },
            {
              value: 'sans_mise_a_prix',
              label: 'Mises à prix manquantes',
            },
            {
              value: 'sans_frais_acheteur',
              label: 'Frais acheteur manquant',
            },
            {
              value: 'sans_frais_vendeur',
              label: 'Frais vendeur manquant',
            },
            {
              value: 'livre_police_manquant',
              label: 'Absent du livre de police numérique',
            },
            {
              value: 'lots_phare',
              label: 'Lots phares',
            },
            {
              value: 'mandat_absent',
              label: 'Mandats absents',
            },
            {
              value: 'mandat_non_signe',
              label: 'Mandats non signés',
            },
          ],
        },
        {
          label: 'Filtres préparation et après vente',
          options: [
            {
              value: 'subjecttotax_true',
              label: 'Vendeur assujetti à la TVA',
            },
            {
              value: 'subjecttotax_false',
              label: 'Vendeur non assujetti à la TVA',
            },
            // {
            //   value: 'tva_none',
            //   label: 'Vendeur Non assujettis à la TVA',
            // },
            {
              value: 'tva_5_5',
              label: 'Catégorie 5,5%',
            },
            {
              value: 'tva_10',
              label: 'Catégorie 10%',
            },
            {
              value: 'tva_20',
              label: 'Catégorie 20%',
            },
            {
              value: 'tva_6',
              label: 'Catégorie 6%',
            },
            {
              value: 'tva_21',
              label: 'Catégorie 21%',
            },
          ],
        },
        {
          label: 'Filtres après de vente',
          options: [
            {
              value: 'drouotonline',
              label: 'Acquéreurs Drouot Live',
            },
            {
              value: 'drouotmoniteur',
              label: 'Acquéreurs Drouot Moniteur Live',
            },
            {
              value: 'interencheres',
              label: 'Acquéreurs Interenchères',
            },
            {
              value: 'cars',
              label: 'Véhicules immatriculés',
            },
            {
              value: 'plate',
              label: 'Avec numéro de plaquette',
            },
            {
              value: 'expert',
              label: 'Avec expert',
            },
            {
              value: 'adj_2000',
              label: 'Adj. >= 2 000€',
            },
            {
              value: 'adj_5000',
              label: 'Adj. >= 5 000€',
            },
            {
              value: 'adj_750_50000',
              label: '750€ <= Adj. <= 50 000€',
            },
            {
              value: 'adj_50000',
              label: 'Adj. > 50 000€',
            },
            {
              value: 'adagp',
              label: 'ADAGP (case cochée sur le lot)',
            },
          ],
        },
      ],
      // sortOptions: [
      //   {
      //     value: 'estimationLowAsc',
      //     label: 'Estimations croissant',
      //   },
      //   {
      //     value: 'estimationLowDesc',
      //     label: 'Estimations décroissant',
      //   },
      //   {
      //     value: 'endPriceAsc',
      //     label: 'Adjudication croissant',
      //   },
      //   {
      //     value: 'endPriceDesc',
      //     label: 'Adjudication décroissant',
      //   },
      //   {
      //     value: 'reservePriceAsc',
      //     label: 'Réserve croissant',
      //   },
      //   {
      //     value: 'reservePriceDesc',
      //     label: 'Réserve décroissant',
      //   },
      // ],
      sortValue: '',
    }
  },
  computed: {
    ...mapState(['user']),
    sortOptions() {
      let options = []
      if (this.parentPage === 'inventoryItemList') {
        options = [
          {
            value: 'estimationLowAsc',
            label: 'Estimations croissant',
          },
          {
            value: 'estimationLowDesc',
            label: 'Estimations décroissant',
          },
          {
            value: 'photos',
            label: 'Nombre de photos',
          },
        ]
      } else {
        options = [
          {
            value: 'estimationLowAsc',
            label: 'Estimations croissant',
          },
          {
            value: 'estimationLowDesc',
            label: 'Estimations décroissant',
          },
          {
            value: 'endPriceAsc',
            label: 'Adjudication croissant',
          },
          {
            value: 'endPriceDesc',
            label: 'Adjudication décroissant',
          },
          {
            value: 'reservePriceAsc',
            label: 'Réserve croissant',
          },
          {
            value: 'reservePriceDesc',
            label: 'Réserve décroissant',
          },
        ]
      }
      return options
    },
  },
  watch: {
    user(newVal) {
      if (newVal) {
        this.addons = newVal.client?.addons ?? 0
      }
    },
  },
  mounted() {
    // eslint-disable-next-line no-console
    //console.log("mounted itemfilters")
    if (this.$route.query.page) {
      this.page = this.$route.query.page as string
    }

    if (this.$route.query.search) {
      this.search = this.$route.query.search as string
    }

    if (this.$route.query.storageArea) {
      this.storageArea = this.$route.query.storageArea as string
    }

    if (this.$route.query.entryDate) {
      this.entryPeriod = this.$route.query.entryDate as string[]
    }

    if (this.$route.query.itemNumber) {
      this.itemNumberFilter = this.$route.query.itemNumber as string
    }

    if (this.$route.query.stockId) {
      this.stockIdFilter = this.$route.query.stockId as string
    }

    if (this.$route.query.sale) {
      // Obligé de précharger si il y en a une dans l'url
      this.fetchSales()
      this.saleFilter = parseInt(this.$route.query.sale as string)
    }

    if (this.$route.query.dateOut) {
      this.dateOutFilter = this.$route.query.dateOut == 'true' ? true : false
    }

    // switch (this.parentPage) {
    //   case 'saleItemList':
    //     this.fetchRequisitions()
    //     this.fetchStructures()
    //     this.fetchExperts()
    //     this.fetchApporteurs()
    //     break
    //   case 'stockItemList':
    //     //this.fetchSales()
    //     this.fetchStructures()
    //     break
    //   default:
    //     //this.fetchSales()
    // }

    if (this.$route.query.requisition) {
      this.fetchRequisitions()
      this.requisitionFilter = parseInt(this.$route.query.requisition as string)
    }

    if (this.$route.query.expert) {
      this.fetchExperts()
      this.expertFilter = parseInt(this.$route.query.expert as string)
    }

    if (this.$route.query.apporteur) {
      this.fetchApporteurs()
      this.apporteurFilter = parseInt(this.$route.query.apporteur as string)
    }

    if (this.$route.query.specialFilter) {
      this.fetchStructures()
      this.specialFilter = this.$route.query.specialFilter as string
    }

    if (this.$route.query.structure) {
      this.fetchStructures()
      this.structureFilter = this.$route.query.structure as string
    }

    if (this.$route.query.sort) {
      this.sortValue = this.$route.query.sort as string
    }

    if (this.user) {
      //this.fetchRubriques()
      this.addons = this.user.client?.addons ?? 0
    }

    if (this.$route.query.rubriques && this.parentPage != 'BoughtItems') {
      // Obligé de précharger les rubrique si il y en a une dans l'url
      this.fetchRubriques(true)
      this.initRubriques()
    }

    this.initStockStatuses()
    //this.updateRoute(false)
  },
  methods: {
    addonTest(code: number) {
      if (!isNaN(this.addons)) {
        return BigInt(code) & BigInt(this.addons)
      } else {
        return false
      }
    },
    updateRoute(resetPage = true, filteringType = '') {
      // eslint-disable-next-line no-console
      // console.log("updateroute itemfilters")

      if (filteringType === 'stock_status') {
        this.updateStatesFilters()
      } else if (filteringType === 'rubriques') {
        this.updateRubriquesFilters()
      }

      if (resetPage) {
        this.page = '1'
      }

      let query = {
        search: this.search,
        storageArea: this.storageArea,
        page: this.page,
        orderby: this.orderBy,
        order: this.order,
        rubriques: this.filteredRubriques,
        stockStatuses: this.filteredStockStatuses,
        entryDate: this.entryPeriod,
        itemNumber: this.itemNumberFilter,
        stockId: this.stockIdFilter,
        sale: this.saleFilter,
        requisition: this.requisitionFilter,
        expert: this.expertFilter,
        apporteur: this.apporteurFilter,
        dateOut: this.dateOutFilter ? 'true' : 'false',
        structure: this.structureFilter,
        specialFilter: this.specialFilter,
        sort: this.sortValue,
      } as Parameter

      let queryString = ''
      switch (this.parentPage) {
        //if (this.parentPage === 'saleItemList') {
        case 'saleItemList':
          query = {
            tab: 'item',
            ...query,
          }
          delete query.page
          delete query.sale
          delete query.entryDate
          delete query.dateOut
          this.$emit('setQuery', query)
          queryString = this.createSearchParams(query).toString()
          // Change the URL whithout reload ==> A finir car au retour tout s'efface... compliqué :/
          history.pushState(null, '', `${this.$route.path}?${queryString}`)
          this.$emit('refreshItemList')
          break
        //} else if (this.parentPage === 'requisitionItemList') {
        case 'requisitionItemList':
          delete query.page
          delete query.requisition
          delete query.entryDate
          delete query.structure
          this.$emit('setQuery', query)
          queryString = this.createSearchParams(query).toString()
          // Change the URL whithout reload ==> A finir car au retour tout s'efface... compliqué :/
          history.pushState(null, '', `${this.$route.path}?${queryString}`)
          this.$emit('refreshItemList')
          break
        //} else {
        case 'stockItemList':
          this.$router.push({ query: Object.assign({}, this.$route.query, query) }).catch(() => {
            // This empty catch method is here to avoid the "Avoided redundant navigation" error
          })
          break
        case 'BoughtItems':
          query = {
            tab: 'items',
            ...query,
          }
          delete query.page
          delete query.requisition
          delete query.entryDate
          delete query.structure
          delete query.dateOut
          delete query.stockId
          delete query.stockStatuses
          this.$router.push({ query: Object.assign({}, this.$route.query, query) }).catch(() => {
            // This empty catch method is here to avoid the "Avoided redundant navigation" error
          })
          break
        case 'inventoryItemList':
          delete query.page
          delete query.requisition
          delete query.entryDate
          delete query.structure
          delete query.sale
          delete query.dateOut
          delete query.stockId
          delete query.stockStatuses
          queryString = this.createSearchParams(query).toString()
          // Change the URL whithout reload ==> A finir car au retour tout s'efface... compliqué :/
          history.pushState(null, '', `${this.$route.path}?${queryString}`)
          this.$emit('setQuery', query)
          this.$emit('refreshItemList')
          break
        default:
      }
    },
    updateRubriquesFilters() {
      this.filteredRubriques = [] as string[]
      this.chosenRubriques.forEach((rubrique: string[]) => {
        rubrique.forEach((value: string) => {
          if (!this.filteredRubriques.includes(value)) {
            this.filteredRubriques.push(value)
          }
        })
      })
    },
    updateStatesFilters() {
      this.filteredStockStatuses = [] as string[]
      this.chosenStockStatuses.forEach((stockStatus: string[]) => {
        stockStatus.forEach((value: string) => {
          if (!this.filteredStockStatuses.includes(value)) {
            this.filteredStockStatuses.push(value)
          }
        })
      })
    },
    fetchSales() {
      if (!this.busy && this.sales.length === 0) {
        this.busy = true
        this.$api
          .get('/sales', {
            params: {
              type: 'simple',
              requisitionId: this.$route.params.requisitionId,
            },
          })
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            this.sales = apiResponse.data
          })
          .catch(() => {
            this.$notify({
              type: 'error',
              title: 'Erreur',
              message: 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          })
          .finally(() => {
            this.busy = false
          })
      }
    },
    fetchRequisitions() {
      if (this.$route.params.saleId && this.requisitions.length === 0) {
        this.$api
          .get(`/sale/${this.$route.params.saleId}/requisitions-list`)
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            this.requisitions = apiResponse.data
          })
          .catch(() => {
            this.$notify({
              type: 'error',
              title: 'Erreur',
              message:
                'Une erreur est survenue dans la récupération de la liste des requisitions. Veuillez nous excuser pour la gêne occasionnée.',
            })
          })
      }
    },
    fetchExperts() {
      if (this.$route.params.saleId && this.experts.length === 0) {
        this.$api
          .get(`/sale/${this.$route.params.saleId}/experts-list`)
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            this.experts = apiResponse.data
          })
          .catch(() => {
            this.$notify({
              type: 'error',
              title: 'Erreur',
              message:
                'Une erreur est survenue dans la récupération de la liste des experts. Veuillez nous excuser pour la gêne occasionnée.',
            })
          })
      }
    },
    fetchApporteurs() {
      if (this.$route.params.saleId && this.apporteurs.length === 0) {
        this.$api
          .get(`/sale/${this.$route.params.saleId}/apporteurs-list`)
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            this.apporteurs = apiResponse.data
          })
          .catch(() => {
            this.$notify({
              type: 'error',
              title: 'Erreur',
              message:
                "Une erreur est survenue dans la récupération de la liste des apporteurs d'affaire. Veuillez nous excuser pour la gêne occasionnée.",
            })
          })
      }
    },
    fetchRubriques(visible: boolean) {
      if (!visible) {
        return
      }
      //if (this.rubriques.length === 0 && this.parentPage !== 'stockItemList') {
      if (this.parentPage == 'stockItemList') {
        // all rubriques
        this.rubriques = this.user.client.config.rubriques
      } else {
        const parentModel = this.parentPage === 'saleItemList' ? 'sale' : 'requisition'
        const parentId =
          this.parentPage === 'saleItemList' ? this.$route.params.saleId : this.$route.params.requisitionId

        this.$api
          .get(`/${parentModel}/${parentId}/rubriques-list`)
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            this.rubriques = apiResponse.data
          })
          .catch(() => {
            this.$notify({
              type: 'error',
              title: 'Erreur',
              message: 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          })
      }
    },
    fetchStructures() {
      if (this.structures.length === 0) {
        this.busy = true
        let url = ''
        let saleId = 0
        if (this.$route.params?.saleId) {
          saleId = parseInt(this.$route.params?.saleId as string)
          url = `/sale/${saleId}/structures`
        } else {
          url = `/structures`
        }
        this.$api
          .get(url)
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            if (saleId) {
              this.structures = apiResponse.data
            } else {
              this.structures = apiResponse.data.map((structure: Structure) => {
                return { structureId: structure.id?.toString(), structureName: structure.name }
              })
            }
          })
          .catch(() => {
            this.$notify({
              type: 'error',
              title: 'Erreur',
              message: 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          })
          .finally(() => {
            this.busy = false
          })
      }
    },
    getSaleTitle(sale: Sale): string {
      let saleTitle = ''
      if (sale?.title) {
        saleTitle += ' ' + sale?.title.slice(0, 40)
      }
      if (sale?.startDate) {
        const date = Date.parse(sale?.startDate)
        if (date) {
          saleTitle += ' - ' + new Intl.DateTimeFormat('fr-FR').format(date)
        }
      }
      return saleTitle !== '' ? saleTitle : '-'
    },
    initRubriques() {
      this.filteredRubriques = []
      this.chosenRubriques = []
      if (typeof this.$route.query.rubriques === 'string') {
        this.filteredRubriques.push(this.$route.query.rubriques)
        this.chosenRubriques.push([this.$route.query.rubriques])
      } else {
        const queryRubriques: string[] = this.$route.query.rubriques as string[]
        let rubriqueArray = [] as string[]
        let parent = {} as Rubrique
        let currentParent = {} as Rubrique
        queryRubriques.forEach((rubrique: string) => {
          parent = this.rubriques.find((rub: Rubrique) => rub.value === rubrique) ?? ({} as Rubrique)
          if (Object.keys(parent).length > 0) {
            currentParent = parent
            if (rubriqueArray.length > 0) {
              rubriqueArray = [] as string[]
            }
            rubriqueArray.push(rubrique)
          } else {
            this.rubriques.forEach((rub: Rubrique) => {
              const child: Rubrique =
                rub.children?.find((rubChild: Rubrique) => rubChild.value === rubrique) ?? ({} as Rubrique)
              if (Object.keys(child).length > 0) {
                rubriqueArray.push(rubrique)
                this.chosenRubriques.push(rubriqueArray)
                rubriqueArray = [] as string[]
                rubriqueArray.push(currentParent.value)
              }
            })
          }
          this.filteredRubriques.push(rubrique)
        })
      }
    },
    initStockStatuses() {
      if (this.parentPage === 'requisitionItemList' || this.parentPage === 'saleItemList') {
        this.filteredStockStatuses = []
        this.chosenStockStatuses = []
      }
      if (this.$route.query.stockStatuses) {
        this.filteredStockStatuses = []
        this.chosenStockStatuses = []
        if (typeof this.$route.query.stockStatuses === 'string') {
          this.filteredStockStatuses.push(this.$route.query.stockStatuses)
          this.chosenStockStatuses.push([this.$route.query.stockStatuses])
        } else {
          const queryStockStatuses: string[] = this.$route.query.stockStatuses as string[]
          queryStockStatuses.forEach((status: string) => {
            this.filteredStockStatuses.push(status)
            this.chosenStockStatuses.push([status])
          })
        }
      }
    },
    filterOptions(node: Record<string, string>, keyword: string) {
      return node.text.toLowerCase().includes(keyword.toLowerCase())
    },
    createSearchParams(params: Parameter) {
      const searchParams = new URLSearchParams()
      Object.entries(params).forEach(([key, values]) => {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            searchParams.append(key, value)
          })
        } else if (values != null) {
          let stringValue = values.toString()
          searchParams.append(key, stringValue)
        }
      })
      return searchParams
    },
    searchExistingStorageArea(queryString: string, cb: CallableFunction) {
      let results = [] as Record<string, string>[]
      const storageAreas = [] as Record<string, string>[]

      this.$api
        .get(`/storage-areas`, {
          params: {
            idSale: this.$route.params.saleId ?? null,
            idRequisition: this.$route.params.requisitionId ?? null,
          },
        })

        .then((response) => {
          const apiResponse = response.data as ApiResponse

          apiResponse.data.forEach((storageArea: string) => {
            storageAreas.push({ value: storageArea })
          })
          results = queryString ? storageAreas.filter(this.createFilter(queryString)) : storageAreas
        })
        .finally(() => {
          cb(results)
        })
    },
    createFilter(queryString: string) {
      return (str: Record<string, string>) => {
        return str.value?.toLowerCase().indexOf(queryString.toLowerCase()) === 0 ?? null
      }
    },
  },
})
